<template>
  <form :action="formAction" :method="effectiveMethod === 'get' ? 'get' : 'post'">
    <input v-if="csrfToken && effectiveMethod !== 'get'" type="hidden" name="authenticity_token" :value="csrfToken">
    <input v-if="effectiveMethod !== 'post' && effectiveMethod !== 'get'" type="hidden" name="_method" :value="effectiveMethod">

    <table class="hv-form-table">
      <tr>
        <th>Hyper Visor Name</th>
        <td><input v-model="name" name="hv[name]" type="text" size="30" class="form-control string required"></td>
      </tr>

      <tr>
        <th>IP address</th>
        <td><input v-model="ipaddress" name="hv[ipaddress]" type="text" size="50" class="form-control string required"></td>
      </tr>

      <tr>
        <th>Has DEFAULT Network ?</th>
        <td>
          <input type="hidden" name="hv[cloudnat]" value="0">
          <label class="vm-switch-toggle">
            <input v-model="cloudnat" name="hv[cloudnat]" type="checkbox" value="1">
            <span class="vm-switch-slider" aria-hidden="true"></span>
            <span class="vm-switch-copy">
              <strong>Default network enabled</strong>
              <small>Attach the built-in DEFAULT network on this hypervisor.</small>
            </span>
          </label>
        </td>
      </tr>

      <tbody>
        <HyperVisorFormControls
          :hvtype-options="hvtypeOptions"
          :initial-hvtype="hvtype"
          :network-options="networkOptions"
        />
      </tbody>

      <tr>
        <th>VXLAN VTEP Interface</th>
        <td><input v-model="vxlanif" name="hv[vxlanif]" type="text" size="50" class="form-control string required"></td>
      </tr>

      <tr>
        <th>Description</th>
        <td><input v-model="description" name="hv[description]" type="text" size="50" class="form-control string required"></td>
      </tr>

      <tr>
        <th>Maintenance Mode</th>
        <td>
          <input type="hidden" name="hv[status]" value="0">
          <label class="vm-switch-toggle">
            <input v-model="maintenanceMode" name="hv[status]" type="checkbox" value="2">
            <span class="vm-switch-slider" aria-hidden="true"></span>
            <span class="vm-switch-copy">
              <strong>Maintenance mode</strong>
              <small>Prevent new workloads and migrate running VMs away when needed.</small>
            </span>
          </label>
        </td>
      </tr>
    </table>

    <div class="vm-form-actions">
      <button type="submit" class="btn btn-primary">{{ submitLabel }}</button>
    </div>
  </form>
</template>

<script setup>
import { ref } from "vue"
import HyperVisorFormControls from "./HyperVisorFormControls.vue"

const props = defineProps({
  formAction: {
    type: String,
    required: true
  },
  formMethod: {
    type: String,
    default: "post"
  },
  submitLabel: {
    type: String,
    default: "Save"
  },
  initialName: {
    type: String,
    default: ""
  },
  initialIpaddress: {
    type: String,
    default: ""
  },
  initialCloudnat: {
    type: Boolean,
    default: false
  },
  initialHvtype: {
    type: [String, Number],
    default: ""
  },
  hvtypeOptions: {
    type: Array,
    default: () => []
  },
  networkOptions: {
    type: Array,
    default: () => []
  },
  initialVxlanif: {
    type: String,
    default: ""
  },
  initialDescription: {
    type: String,
    default: ""
  },
  initialMaintenanceMode: {
    type: Boolean,
    default: false
  }
})

const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""
const effectiveMethod = props.formMethod.toLowerCase()
const name = ref(props.initialName)
const ipaddress = ref(props.initialIpaddress)
const cloudnat = ref(!!props.initialCloudnat)
const hvtype = ref(String(props.initialHvtype || ""))
const vxlanif = ref(props.initialVxlanif)
const description = ref(props.initialDescription)
const maintenanceMode = ref(!!props.initialMaintenanceMode)
</script>
